var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 210 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.7272px",
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat Bold'",
      fill: "#be6adf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.58345,
      strokeOpacity: 1
    },
    x: 29.27,
    y: 84.35,
    transform: "scale(.9202 1.08672)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.7272px",
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat Bold'",
      fill: "#be6adf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.58345,
      strokeOpacity: 1
    },
    x: 29.27,
    y: 84.35
  }, "&lt;GA/&gt;")), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#be6adf",
      strokeWidth: 9.61207,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 200.39,
    height: 130.39,
    x: 4.81,
    y: 4.81,
    ry: 27.14
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b01067c24f2109ae80de85688925b6ed.svg";
export { ForwardRef as ReactComponent };